/**
 * Clamps long content to a number of lines and reveals the rest on click.
 * Mirrors the show more/less behaviour of <quick-links>.
 */
if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.read-more__content');
      this.toggle = this.querySelector('.read-more__toggle');

      if (!this.content || !this.toggle) return;

      this.toggle.addEventListener('click', this.handleToggle.bind(this));

      let resizeTimer;
      this.resizeObserver = new ResizeObserver(() => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(this.updateClipped.bind(this), 200);
      });
    }

    connectedCallback() {
      if (!this.resizeObserver) return;
      this.updateClipped();
      this.resizeObserver.observe(this.content);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    get isExpanded() {
      return this.classList.contains('is-expanded');
    }

    /**
     * Shows the toggle only when the content is actually taller than the clamp.
     */
    updateClipped() {
      if (this.isExpanded) return;
      this.classList.toggle('is-clipped', this.content.scrollHeight - this.content.clientHeight > 2);
    }

    /**
     * Handles 'click' events on the toggle element.
     * @param {object} evt - Event object.
     */
    handleToggle(evt) {
      evt.preventDefault();

      // Pin the natural height so the expanded state can transition to it.
      this.style.setProperty('--read-more-content-height', `${Math.round(this.content.scrollHeight)}px`);

      const expanded = !this.isExpanded;
      this.classList.toggle('is-expanded', expanded);
      this.toggle.textContent = expanded ? this.dataset.showLessText : this.dataset.showMoreText;
      this.toggle.setAttribute('aria-expanded', expanded);
    }
  }

  customElements.define('read-more', ReadMore);
}
